export default class InvalidSceneError extends Error {
    public name = "InvalidSceneError";
}
